import React from "react";

const DashboardPage = () => {
  return <h1>Dashboard Page</h1>;
};

export { DashboardPage };
